import { Card } from 'antd';
import { Column, Title } from '@ydistri/ds';
import { COLORS, computeRemSize } from '@ydistri/theme';
import React, { PropsWithChildren } from 'react';
import { styled } from 'styled-components';

const AdministrationFiltersPanelWrapper = styled(Card)`
  background-color: ${COLORS.GREY_LIGHT};
`;

type AdministrationFiltersPanelProps = PropsWithChildren;

const AdministrationFiltersPanel: React.FC<AdministrationFiltersPanelProps> = ({ children }) => (
  <AdministrationFiltersPanelWrapper size="small">
    <Title>Filters and sorting:</Title>
    <Column $gap={computeRemSize(8)} $alignItems="flex-start" $padding={2}>
      {children}
    </Column>
  </AdministrationFiltersPanelWrapper>
);

export default AdministrationFiltersPanel;
